export default __webpack_public_path__ + "static/slider3-res-c2e001f21550c107fdcec6b28659bb63.png";